"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderCartClickDL } from "./HeaderAnalyticsFunction";

interface HeadercartProps {
  headercart?: {
    ctaInNewTab: string;
    ctaLink: string;
    defaultCount: string;
    heading: string;
    maxCount: string;
    showOnApp: string;
    showOnWeb: string;
  };
}

const Cart: React.FC<HeadercartProps> = ({ headercart }) => {
  const cartUrl = "/webform/v1/mycart?v1=/webform/v1/mycart&sso-module=cart";

  return (
    <BFLLink
      href={cartUrl}
      aria-label={headercart?.heading ?? "Cart"}
      onClick={() => handleHeaderCartClickDL(cartUrl)}
      className="order-3 mx-0 my-0 flex flex-col items-center md:pt-[14px] md:pb-[8px] hover:bg-[#001326] md:order-3 md:gap-[5px] min-w-[44.05px] md:min-w-[56.62px]!"
    >
      <i className="bf-icon-new-cart text-2xl" data-testid="cart-icon"></i>
      <span className="hidden text-xs leading-[14px] md:!block font-normal [font-family:Rubik,Mukta,BalooThambi2,sans-serif]" data-testid="cart-heading">
        {headercart?.heading}
      </span>
    </BFLLink>
  );
};
export default Cart;
